import {
  Checkbox as MuiCheckbox,
  FormControlLabel as MuiFormControlLabel,
} from '@mui/material';
import Accordion from 'components/Accordion';
import { useTranslation } from 'react-i18next';

export const riskList = [
  { value: 'NO_RISK', label: 'No risk' },
  { value: 'VERY_LOW_RISK', label: 'Very low risk' },
  { value: 'LOW_RISK', label: 'Low risk' },
  { value: 'MEDIUM_RISK', label: 'Medium risk' },
  { value: 'HIGH_RISK', label: 'High risk' },
  { value: 'VERY_HIGH_RISK', label: 'Very high risk' },
];

export default function RiskFilter({ setFilters, filters, defaultExpanded = false }) {
  const { t } = useTranslation();
  return (
    <Accordion title={t('Risk')} defaultExpanded={defaultExpanded}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {riskList.map((item) => {
          return (
            <MuiFormControlLabel
              key={item.value}
              control={
                <MuiCheckbox
                  checked={!!filters?.risk?.find((risk) => risk === item.value)}
                  onClick={(e) => {
                    setFilters((curr) => ({
                      ...curr,
                      risk: e.target.checked
                        ? [...curr.risk, item.value]
                        : curr.risk.filter((risk) => risk !== item.value),
                    }));
                  }}
                />
              }
              label={t(item.label)}
            />
          );
        })}
      </div>
    </Accordion>
  );
}
